<template>
  <div id="fazWahlDashboard" v-if="loaded">
    <div class="dachzeile">Bundestagswahl 2021</div>
    <div class="headline">Ergebnisse in den Wahlkreisen</div>
    <div class="subheadline" v-if="mapView.description">{{mapView.description}}</div>
    <div class="grid-x align-center relative">
      <!-- <div class="cell small-12 large-8"> -->
        <div class="radio" v-if="$mq!='s'">
          <div v-for="view in mapViews" :key="view.label">
            <input type="radio" :id="view.label" :value="view" v-model="mapView">
            <label :for="view.label" @click="resetParty()"> {{view.label}}</label>
          </div>
        </div>
        <div v-else>
          <select v-model="mapView" class="dropdown" >
            <option v-for="view in mapViews" :key="view.label" :value="view">{{view.label}}</option>
          </select>
        </div>
      <!-- </div> -->
    </div>
    <br>
    <div class="cell small-12" v-if="$mq=='s'">
        <div class="regionSelect">
          <multiselect 
            v-model="selectedRegion" 
            :options="multiselectOptions" 
            :show-labels="false" 
            placeholder="Suchen Sie Ihren Wahlkreis"
            track-by="id"
            label="name"
            object="false"
            @select="select">
          </multiselect>
        </div>
    </div>
    <div class="grid-x grid-margin-x relative" v-if="true">
      <div class="cell small-12 medium-7">
        <!-- <div class="chartWrapper">
          <div class="chartWrapper_headline" v-if="election=='Gemeindewahl'">Stärkste Partei in den Gemeinden</div>
          <div class="chartWrapper_headline" v-else>Stärkste Partei in den Kreisen</div> -->
          <!-- <div class="chartWrapper_subheadline">in den Gemeinden</div> -->
          <Map 
            :geoJson="wahlkreiseMap"
            :geoJsonSupraregional="blMap"
            :data="mapData"
            :settings="mapSettings"
            v-model="selectedRegion"
            :year="year"
          />
          <!-- :regionKey="'WKR_NR'"
            :regionName="'GEN'" :markers="cities" v-model="hover" -->
        <!-- </div> -->
      </div>
      <div class="cell small-12 medium-5">
        <div class="regionSelect" v-if="$mq!='s'">
          <multiselect 
            v-model="selectedRegion" 
            :options="multiselectOptions" 
            :show-labels="false" 
            placeholder="Suchen Sie Ihren Wahlkreis"
            track-by="id"
            label="name"
            object="false"
            @select="select">
          </multiselect>
        </div>
        <div class="regionResults" v-if="activeRegion&&activeRegion.id!=0">
          <div class="close" @click="resetRegion">✕</div>
          <div class="headline">{{selectedRegion.name}}</div>
          <div class="subheadline" v-if="summaryWinners[0].status">Vorläufiges Endergebnis</div>
          <div class="divider"></div>
          <div>Wahlbeteiligung: <span>{{format(activeRegion.waehlende_prozent)}}%</span> ({{formatPM(activeRegion.waehlende_prozent_diff)}})</div>
          <div class="divider"></div>
          <div>Direkt gewählt: <span>{{activeRegion.direktkandidat}}</span> ({{activeRegion.erststimmen[0].id}})</div>
          <div class="divider"></div>
          <div><span>Erststimmen</span> (Kandidaten)</div>
          <!-- <div>{{activeRegion.results.slice(0,6)}}</div> -->
          <ColumnChart 
            :data="voteDistribution(activeRegion.erststimmen.slice(0,6))"
            :colors="parties"
            :height="150"
            :suffix="'%'"
            :font-size="13"
            :baseline="true"
            :elipsis="false"
          />
          <div class="divider"></div>
          <div><span>Zweitstimmen</span> (Parteien)</div>
          <!-- {{activeRegion.results.slice(0,6)}} -->
          <ColumnChart 
            :data="voteDistribution(activeRegion.zweitstimmen.slice(0,6))"
            :colors="parties"
            :height="150"
            :suffix="'%'"
            :font-size="13"
            :baseline="true"
            :elipsis="false"
          />
        </div>
        <div class="regionResults" v-else-if="$mq!='s'&&summaryWinners[0].id==0">
          <div class="headline">So hat Deutschland gewählt</div>
          <div class="subheadline" v-if="summaryWinners[0].status">Vorläufiges Endergebnis</div>
          <div class="divider"></div>
          <div>Wahlbeteiligung: <span>{{format(summaryWinners[0].waehlende_prozent)}}%</span> ({{formatPM(summaryWinners[0].waehlende_prozent_diff)}})</div> 
          <div class="divider"></div>
          <div><span>Zweitstimmen</span> (Parteien)</div>
          <!-- {{activeRegion.results.slice(0,6)}} -->
          <ColumnChart 
            :data="bundErgebnisse"
            :colors="partiesBund"
            :height="150"
            :suffix="'%'"
            :font-size="13"
            :baseline="true"
            :elipsis="false"
          />
        </div>
      </div>
    </div>
    <div class="grid-x align-center relative">
      <!-- <div class="cell small-12 large-8"> -->
        <div class="radio" v-if="$mq!='s'">
          <div class="label">Stärke der Parteien</div>
          <div v-for="party in parties.slice(0,7)" v-bind:key="party.label" class="button">
            <!-- <div class="bullet" :style="{backgroundColor: party.color}"></div> -->
            <input type="radio" :id="party.id" :value="party" v-model="selectedParty">
            <label :for="party.id" :data-color="party.color" class="hasBullet"><span class="bullet" :style="{backgroundColor: party.color}"></span> {{party.label}}</label>
            <div class="close" @click="selectedParty={label:'Partei auswählen'}">✕</div>
          </div>
        </div>
        <div v-else>
          <div class="selectLabel">Stärke der Parteien</div>
          <select v-model="selectedParty" class="dropdown">
            <option :value="{label:'Partei auswählen'}">Partei auswählen</option>
            <option v-for="party in parties.slice(0,7)" :key="party.label" :value="party">{{party.label}}</option>
          </select>
        </div>
      <!-- </div> -->
    </div>
    <div class="footnote">
      <span v-if="summaryWinners[0].stand">Stand: {{summaryWinners[0].stand}}<br></span>
      Grafik:&nbsp;Giesel / Quelle:&nbsp;Bundeswahlleiter
    </div>
  </div>
</template>

<script>
import wahlkreiseMap from './assets/maps/wahlkreise2021.json'
import bundeslaenderMap from './assets/maps/bl.json'
import Map from './components/Map.vue'
import ColumnChart from './components/ColumnChart.vue'

import {csvParse } from 'd3' //, format
import * as d3 from 'd3'
import Multiselect from 'vue-multiselect'

export default {
  name: 'app',
  components: {
    Map,
    ColumnChart,
    Multiselect
  },
  data () {
    return {
      env: process.env.NODE_ENV,
      loaded: false,
      stage: "trend",
      date: null,
      dataHessen: null,
      wahlkreiseMap: wahlkreiseMap,
      blMap: bundeslaenderMap,
      mapViews: [
        {label: "Direktkandidaten", description: "Partei der gewählten Direktkandidaten (Erststimmen)"},
        {label: "Machtwechsel", description: "Direktmandate, die bisher von einer anderen Partei gehalten werden"},
        {label: "Zweitstimmen", description: "Stärkste Partei nach Zweitstimmenanteil"},
        {label: "Zweitstärkste", description: "Zweitstärkste Partei nach Zweitstimmenanteil"},
        {label: "Wahlbeteiligung", description: "Wahlbeteiligung in Prozent"},
      ],
      mapView: {label: "Direktkandidaten", description: "Partei der gewählten Direktkandidaten (Erststimmen)"},
      selectedParty: {label: "Partei auswählen"},
      year: "2021",
      selectedRegion: {id: 0, name: "Suchen Sie Ihren Wahlkreis"},
      parties: [ 
        {label: "SPD", id: "SPD", color: "#c51d1e"},
        {label: "CDU", id: "CDU", color: "#333"},
        {label: "CSU", id: "CSU", color: "#333"},
        {label: "Grüne", id: "GRÜNE", color: "#0c9941"},
        {label: "FDP", id: "FDP", color: "#f6c909"},
        {label: "AfD", id: "AfD", color: "#2b7ab4"},
        {label: "Linke", id: "DIE LINKE", color: "#bb4894"},
        {label: "Die PARTEI", id: "Die PARTEI", color: "#B92837"},
        {label: "FW", id: "FREIE WÄHLER", color: "#b5b9bc"},
        {label: "Piraten", id: "PIRATEN", color: "#f39200"},
        {label: "REP", id: "REP", color: "#a07e26"},
        {label: "NPD", id: "NPD", color: "#a07e26"},
        {label: "Einheit", id: "EINHEIT", color: "#a284c7"},
        {label: "Volt", id: "Volt", color: "#502379"},
        {label: "Humanisten", id: "HUMANISTEN", color: "#d90368"},
        {label: "DKP", id: "DKP", color: "red"},
      ],
      cities: [
        {label: 'Frankfurt', long: '50.1013195', lat: '8.653302', anchor: 'middle'},
      ],
      emptyData: {
        "cols":[
          {"label":"","id":"a","color":"#dfdfdf"},
          {"label":"","id":"b","color":"#cfcfcf"},
          {"label":"","id":"c","color":"#efefef"},
        ],
        "rows":[[3,2,1]]
      },
      summaryWinners: null,
      wahlkreise: null,
    }
  },
  watch: {
    election: function () {
      this.selectedRegion = null
    },
    selectedParty: function () {
      this.mapView = {label: "Zweitstimmen", description: "Zweitstimmenanteil " + this.selectedParty.label}
    },
    // mapView: function () {
    //   this.selectedParty = {label: "Partei auswählen"}
    // }
  },
  computed: {
    stageString () {
      switch (this.stage) {
        case "empty":
          return 'Trendergebnisse ab 19:30'
        case "trend":
          return "Trendergebnisse"
        case "vorl":
          return "Vorläufige Ergebnisse"
        case "endg":
          return "Endgültige Ergebnisse"
        default:
          return "Trendergebnisse"
      }
    },
    activeParty () {
      return this.parties.find( party => party.label == this.mapView)
    },
    activeRegion () {
      return this.summaryWinners.find( wk => parseInt(wk.id) === this.selectedRegion.id )
    },
    multiselectOptions () {
      return this.wahlkreiseMap.features.map( kreis => {
        return {
          id: kreis.properties.WKR_NR,
          name: kreis.properties.WKR_NAME
        }
      })
    },
    mapData () {
      // if (this.selectedParty == null) {
        return this.wahlkreiseMap.features.map( region => {
          let match = this.summaryWinners.find( wk => parseInt(wk.id) === region.properties.WKR_NR)
          // console.log(match)
          if(!match) {
            return {
              category: 'Noch nicht ausgezählt',
              regionKey: parseInt(region.properties.WKR_NR),
              regionName: region.properties.WKR_NAME,
              tooltip: []
            }
          } else {
            let obj = {
              regionKey: parseInt(region.properties.WKR_NR),
              regionName: region.properties.WKR_NAME,
              tooltip: [match.id, match.waehlende_prozent]
            }
            if (this.selectedParty.id == null) {
              switch (this.mapView.label) {
                case "Zweitstimmen":
                  obj.category = match.zweitstimmen.sort( (a,b) => b.stimmen - a.stimmen)[0].id
                  obj.tooltip = match.zweitstimmen.slice(0,6).map(el => {
                    return { 
                      label: (this.parties.find( party => party.id === el.id)||{}).label||el.id, 
                      value: el.prozent, 
                      color: (this.parties.find(party => party.id == el.id)||{}).color||'#ddd'
                    }
                  })
                  return obj
                case "Direktkandidaten":
                  match.erststimmen.sort( (a,b) => b.stimmen - a.stimmen)
                  obj.category = match.erststimmen[0].id
                  obj.tooltip = match.erststimmen.slice(0,6).map(el => {
                    return { 
                      label: (this.parties.find( party => party.id === el.id)||{}).label||el.id, 
                      value: el.prozent, 
                      color: (this.parties.find(party => party.id == el.id)||{}).color||'#ddd'
                    }
                  })
                  return obj
                case "Zweitstärkste":
                  obj.category = match.zweitstimmen.sort( (a,b) => b.stimmen - a.stimmen)[1].id
                  obj.tooltip = match.zweitstimmen.slice(0,6).map(el => {
                    return { 
                      label: (this.parties.find( party => party.id === el.id)||{}).label||el.id, 
                      value: el.prozent, 
                      color: (this.parties.find(party => party.id == el.id)||{}).color||'#ddd'
                    }
                  })
                  return obj
                case "Wahlbeteiligung":
                  match.zweitstimmen.sort( (a,b) => b.stimmen - a.stimmen)
                  obj.value = match.waehlende_prozent
                  obj.tooltip = ['Wahlbeteiligung: '+ this.format(match.waehlende_prozent) + '%']
                  return obj
                case "Machtwechsel":
                  var wahl = match.erststimmen.sort( (a,b) => b.stimmen - a.stimmen)[0].id
                  var vorwahl = match.erststimmen.sort( (a,b) => b.stimmen_vorwahl - a.stimmen_vorwahl)[0].id
                  obj.category = wahl == vorwahl ? '' : wahl
                  match.erststimmen.sort( (a,b) => b.stimmen - a.stimmen)
                  obj.tooltip = match.erststimmen.slice(0,6).map(el => {
                    return { 
                      label: (this.parties.find( party => party.id === el.id)||{}).label||el.id, 
                      value: el.prozent, 
                      color: (this.parties.find(party => party.id == el.id)||{}).color||'#ddd'
                    }
                  })
                  return obj
                default:
                  return obj
              }
            } else {
              obj.value = ((match.zweitstimmen.find( el => el.id == this.selectedParty.id)||0).prozent||0)
              obj.tooltip = match.zweitstimmen.slice(0,6).map(el => {
                return { 
                  label: (this.parties.find( party => party.id === el.id)||{}).label||el.id, 
                  value: el.prozent, 
                  color: (this.parties.find(party => party.id == el.id)||{}).color||'#ddd'
                }
              })
              return obj
            }
          }
        })
    },
    mapSettings () {
      let settings = {
        title: "Stärkste Partei",
        type: "category",
        regionKey: 'WKR_NR',
        colors: this.parties,
        suffix: "%",
        legend: false
      }
      if (this.selectedParty.id == null) {
        switch (this.mapView.label) {
          case "Zweitstimmen":
            return settings
          case "Direktkandidaten":
            return settings
          case "Zweitstärkste":
            return settings
          case "Machtwechsel":
            return settings
          case "Wahlbeteiligung":
            settings.title = "Wahlbeteiligung"
            settings.type = "heatmap"
            settings.domain = [60,80]
            settings.range = ['#efefef', '#0091a0'] //#e97a00
            settings.legend = true   
        }
      } else {
        settings.title = this.selectedParty.label
        settings.type = "heatmap"
        let max = Math.max.apply(Math, this.summaryWinners.map( el => {
          // console.log(el.zweitstimmen.find( el => el.id == this.selectedParty.id).prozent)
          return (el.zweitstimmen.find( el => el.id == this.selectedParty.id)||{}).prozent||0
        }))
        settings.domain = [0, Math.max(Math.floor(parseFloat(max)/10)*10,10)]
        settings.range = ['#fff', this.selectedParty.color] //#e97a00
        settings.legend = true
      }
      return settings
    },
    bundErgebnisse () {
      let zweitstimmen_bund = this.summaryWinners[0].zweitstimmen
      let stimmen_gesamt = zweitstimmen_bund.reduce( (accumulator, currentValue) => { 
        return accumulator + currentValue.stimmen
      }, 0)
      let cdu = zweitstimmen_bund.find(el => el.id == 'CDU')
      let csu = zweitstimmen_bund.find(el => el.id == 'CSU')
      let union = {
        id: "Union",
        prozent: Math.round(1000*(cdu.stimmen+csu.stimmen)/parseFloat(stimmen_gesamt))/10,
        stimmen: cdu.stimmen+csu.stimmen,
        prozent_vorwahl: cdu.prozent_vorwahl+csu.prozent_vorwahl,
        prozent_diff: (cdu.prozent+csu.prozent) - (cdu.prozent_vorwahl+csu.prozent_vorwahl)
      }
      zweitstimmen_bund.push(union)
      zweitstimmen_bund = zweitstimmen_bund.filter( el => el.id != 'CDU' && el.id != 'CSU')
      zweitstimmen_bund.sort( (a,b) => b.stimmen - a.stimmen)
      // console.log(zweitstimmen_bund)
      
      return this.voteDistribution(zweitstimmen_bund.slice(0,6))
    },
    partiesBund () {
      return [...[{label: "Union", id: "Union", color: "#333"}], ...this.parties] 
    }
  },
  methods: {
    getData () {
      let data_url = process.env.BASE_URL + 'data/kerg2.json'
      // let data_url = this.env == 'development' ?
      //   process.env.BASE_URL + 'data/kerg2.json' : 
      //   'https://cdn.faz-azure.com/multimediaredaktion/btw21/kerg2.json?sv=2020-04-08&st=2021-09-16T15%3A09%3A22Z&se=2222-09-17T15%3A09%3A00Z&sr=c&sp=rl&sig=6u%2FGUPiOM40JAhrDZyeXp4dPstcqsxWA9o5HtR%2BFT8Q%3D'

      let fetches = [ //https://cdn.faz-azure.com/multimediaredaktion/btw21/kerg2.json?sv=2020-04-08&st=2021-08-16T15%3A31%3A53Z&se=2022-08-17T15%3A31%3A00Z&sr=b&sp=r&sig=aTU4PNMtA%2BSJ4NIxGvVQGdcbfvVOnXtFPa%2FpulCe5FM%3D
        fetch(data_url).then(r => r.json()), //'https://datalakeanalyticssandbox.blob.core.windows.net/raw/multimedia_redaktion/btw21/kerg2.json?sv=2020-04-08&st=2021-09-02T09%3A16%3A51Z&se=2022-09-03T09%3A16%3A00Z&sr=b&sp=r&sig=R3y2hglpDQVpnH2GCrq6708DnEfP8BaBJODK7KAaHd8%3D'
        fetch(process.env.BASE_URL + 'data/wahlkreise.json').then(r => r.json()), //'https://cdn.faz-azure.com/multimediaredaktion/btw21/summaryWinners.json?sv=2020-04-08&st=2021-08-16T14%3A44%3A11Z&se=2022-08-17T14%3A44%3A00Z&sr=b&sp=r&sig=q0fFnytCeVkSRpOFmSsRkSNGUImt7j1zmKJh%2FGIlQOg%3D'
      ]
      Promise.all(fetches).then((results) => {
        this.summaryWinners = results[0]
        this.wahlkreise = results[1]
        this.loaded = true
      })

      setTimeout( () => { 
        this.getData()
        // console.log("Update!")
      }, 60000)
    },
    voteDistribution (arr) {
      let rows = arr.map( el => el.prozent)
      let others = 100-arr.reduce( (accumulator, currentValue) => { 
        return accumulator + currentValue.prozent
      }, 0)
      others = Math.round(others*10)/10

      let cols = arr.map( el => {
        return {
          "label": (this.parties.find( party => party.id === el.id)||{}).label||el.id,
          "id": el.id,
          "color": el.id == 'Union' ? '#333' :
          (this.parties.find( party => party.id === el.id)||{}).color||'#ddd'
        }
      })

      if(others>0) {
        rows.push(others)
        cols.push({
          "label": "Sonst.",
          "id": "Sonst.",
          "color": "#ddd"
        })
      }

      return {
        "cols" : cols,
        "rows" : [rows]
      }
    },
    removeFirstLine (string) {
      let lines = string.split('\n')
      lines.splice(0,1)
      return lines.join('\n')
    },
    parseCsv (csv) {
      return csvParse(csv)
    },
    parseDsv (csv) {
      let dsv = d3.dsvFormat(";")
      return dsv.parse(csv)
    },
    parse2016 (csv) {
      let dsv = d3.dsvFormat(";")
      return dsv.parse(csv, region => {        
        return region
      })
    },
    format (num) {
      return String(num).replace('.',',')
    },
    formatPM (number) {
      let prefix = ''
      
      if (number==0) { prefix = '±' } 
      else if (number > 0) { prefix = '+' } 
      else { prefix = ''}
      
      return prefix + String(number).replace('.',',')
    },
    select () {
      // this.hover = 42
      // this.activeRegion = this.selectedRegion
    },
    resetRegion () {
      this.selectedRegion = {
        id: 0,
        name: 'Suchen Sie Ihren Wahlkreis'
      }
    },
    resetParty () {
      this.selectedParty = {label: "Partei auswählen"}
    }
  },
  mounted () {
    this.stage = document.getElementById("app-settings").dataset.stage
    this.date = document.getElementById("app-settings").dataset.date
    this.getData()
  }
}
</script>

<style scoped src="./assets/foundation.css">
</style>

<style scoped lang="scss">
@import './assets/reset.scss';
@import './assets/vue-multiselect.min.css';
@import './assets/fonts.scss';
@import './assets/style.scss';
</style>

<style>
.multiselect {
  border: 1px solid #ddd !important;
  border-radius: 4px !important;
}

.multiselect__single {
  color: #999;
}

.multiselect__tags {
  border-color: #ddd;
  padding: 8px 40px 0 15px;
  background: #fff;
}

.multiselect__select {
  background-image: url("./assets/icons/suche-19-x-20.svg");
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: 50%;
  opacity: .5;
}
.multiselect__select:before {
  display: none;
}
.multiselect--active .multiselect__select {
  transform: none;
  opacity: 0;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: inherit;
  background: #fff;
}
</style>